import { OPTIONS_TAB_COUPONS, useCoupon } from '@hooks';
import { PageHeader } from '@organisms';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { TabComponent } from 'src/app/components/antd/TabComponent';

import { AddCouponModal } from './components/AddCouponModal/AddCouponModal.component';
import { CouponsDigitalProducts } from './components/ListCoupons/CouponsDigitalProducts';
import { CouponsPhysicalProducts } from './components/ListCoupons/CouponsPhysicalProducts';

export const CouponPage: React.FC = () => {
  const {
    isSelectAddCouponModalOpen,
    handleCloseModalCoupon,
    handleOpenModalCoupon,
    tabActive,
    handleSetTabActive,
  } = useCoupon();

  const navigate = useNavigate();

  return (
    <>
      <PageHeader
        backToPath={() => {
          navigate(-1);
        }}
        title={'Gestão de Cupons'}
        subTitle={'Cadastrar, editar e configurar todos os cupons do checkout.'}
      />
      <TabComponent
        tabList={OPTIONS_TAB_COUPONS}
        onChangeTab={handleSetTabActive}
        defaultActiveKey={tabActive}
      />
      {tabActive === '0' && (
        <CouponsPhysicalProducts onOpenModalCoupon={handleOpenModalCoupon} />
      )}
      {tabActive === '1' && (
        <CouponsDigitalProducts onOpenModalCoupon={handleOpenModalCoupon} />
      )}
      <AddCouponModal
        modalIsOpen={isSelectAddCouponModalOpen}
        onCloseModal={handleCloseModalCoupon}
      />
    </>
  );
};
